import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import "./app/styles/_index.scss"

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);